import { useCallback, useMemo } from 'react'
import { useIntl } from 'react-intl'
import { FilterDropdown, FilterDropdownItemProps } from '@carto/meridian-ds/components'
import { SortOutlined } from '@mui/icons-material'

import { SortDirection } from 'features/common/types'

import { MapFieldToOrderBy, MapsOrder } from 'features/maps/types'
import { ContextMenuItem } from 'features/common/ui/ContextMenu'

interface MapsOrderSelectorProps {
  order: MapsOrder
  onOrderChange: (order: MapsOrder) => void
}

function MapsOrderSelector({ order, onOrderChange }: MapsOrderSelectorProps) {
  const intl = useIntl()

  const orderItems = useMemo(
    () => [
      {
        id: MapFieldToOrderBy.UpdatedAt,
        label: intl.formatMessage({ id: 'maps.filters.order.updatedAt' }),
        direction: SortDirection.Desc
      },
      {
        id: MapFieldToOrderBy.Title,
        label: 'A-Z',
        direction: SortDirection.Asc
      }
    ],
    [intl]
  )

  const getMapsOrderFromItem = (selectedItem: ContextMenuItem): MapsOrder => {
    const orderItem = orderItems.find((item) => item.id === selectedItem.id)
    if (!orderItem) throw TypeError()

    const mapsOrder = {
      by: orderItem.id,
      direction: orderItem.direction
    }
    return mapsOrder
  }
  const getItemFromMapsOrder = useCallback(
    (order: MapsOrder): FilterDropdownItemProps => {
      const item = orderItems.find((item) => item.id === order.by && item.direction === order.direction)
      if (!item) throw TypeError()
      return item
    },
    [orderItems]
  )

  const handleItemClick = (selectedItem: ContextMenuItem) => {
    const mapOrder = getMapsOrderFromItem(selectedItem)
    onOrderChange(mapOrder)
  }

  return (
    <FilterDropdown
      icon={<SortOutlined />}
      menuItems={orderItems}
      onClickItem={handleItemClick}
      defaultValue={getItemFromMapsOrder(order)}
      responsive
    />
  )
}

export default MapsOrderSelector
